<app-header></app-header>
<div class="flex flex-wrap">
    <div class="w-full sm:w-8/12 mb-10">
      <div class="container mx-auto h-full sm:p-10">
        <nav class="flex px-4 justify-between items-center">
          <div class="text-4xl font-bold">
            Prepárate. Aplica. Llega a España<span class="text-vjblue">.</span>
          </div>
          
        </nav>
        <header class="container px-4 lg:flex mt-10 items-center h-full lg:mt-0">
          <div class="w-full">
            <h1 class="text-4xl lg:text-6xl font-bold">VoyJaleas tu <span class="text-vjblue"> aliado experto</span> para obtener el Visado de Estudios en España

            </h1>
            <div class="w-20 h-2 text-vjblue my-4"></div>
            <p class="text-xl mb-10">En VoyJaleas, te guiamos paso a paso para obtener tu visado de estudios sin estrés ni confusión. Desde la revisión de tus documentos hasta la preparación para tu cita consular, te ofrecemos una consultoría personalizada con toda la experiencia que necesitás para lograrlo a la primera.</p>
            <button class="vjblue text-white text-2xl font-medium px-4 py-2 rounded shadow" (click)="goToWebapp()">Quiero mi visado sin dudas ni estrés</button>
            <br>
            <br>
            <a class="btn btn-outline-secondary" (click)="goToCalendly()">¿Dudas? Reserva una videollamada GRATIS</a>
          </div>
        </header>
      </div>
    </div>
    <img src="https://voyjaleas-website.sebtec12.workers.dev/student-europe-girl-1.jpg" alt="Leafs" class="w-full h-48 object-cover sm:h-screen sm:w-4/12">
</div>

<app-product-offer></app-product-offer>

<app-webapp-banner></app-webapp-banner>

<!-- <app-testimonial-a></app-testimonial-a> -->
<!-- <app-page-title [pageTitleA]="'Casos de '" [pageTitleB]="'éxito'" [pageSubtitle]=""></app-page-title>
<app-testimonial-carousel></app-testimonial-carousel> -->
<!-- Photo by <a href="https://unsplash.com/@quique_olivar?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Quique Olivar</a> on <a href="https://unsplash.com/photos/brown-building-during-nighttime-CRMjqDZwxS4?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> -->
<app-footer-landing></app-footer-landing>